import React from 'react';
import API from '../../configAPI';
import ProductItem from './ProductItem';
import PulseLoader from 'react-spinners/PulseLoader';
class ProductsPrev extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            products : [],
            loading : true
        }
    }
    componentDidMount(){
        API.PRODUCTS('products/rand')
        .then(resp =>{
            this.setState({
                products : resp.data,
                loading: false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    render(){
        return(
            <div className="row d-flex flex-wrap mt-3">
                <div className="col-12 d-flex justify-content-center">
                    <PulseLoader
                        size={8}
                        margin="1px"
                        color={'#000000'}
                        loading={this.state.loading}
                    />
                </div>
                <ProductItem products={this.state.products}/>
            </div>
        )
    }
}

export default ProductsPrev;